import { Grid, useMediaQuery } from "@mui/material";
import MainCard from "components/MainCard";
import { useTranslation } from "react-i18next";
import ClientDetailChart from "../ClientDetailChart";

export default({model, period, loaded}) => {
    const [t, i18n] = useTranslation();
    const chartHeight = 250;
    const matchDownMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const chartGridXs = (matchDownMD || period == 'WEEKLY') ? 12 : 6;
    return(
        <MainCard title="Outflow statistics">
            <Grid container spacing={3}>
                <Grid item xs={chartGridXs}>
                    <ClientDetailChart model={model} title={t('total')} type="total" section="outflow" height={chartHeight} periodType={period} loaded={loaded} />
                </Grid>
                <Grid item xs={chartGridXs}>
                    <ClientDetailChart model={model} title={t('count')} type="count" section="outflow" height={chartHeight} periodType={period} loaded={loaded} />
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={chartGridXs}>
                    <ClientDetailChart model={model} title={t('average')} type="average" section="outflow" height={chartHeight} periodType={period} loaded={loaded} />
                </Grid>
                <Grid item xs={chartGridXs}>
                    <ClientDetailChart model={model} title={t('median')} type="median" section="outflow" height={chartHeight} periodType={period} loaded={loaded} />
                </Grid>
            </Grid>
      </MainCard>        
    );
}